<div class="container">
  <main role="main" class="form-signin w-100 m-auto text-center">
    <h1>404</h1>
    <p>That page doesn't exist.</p>
  </main>
</div>
